import { Controller } from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['alert']

  save() {
    this.alertTarget.classList.add('d-none')
    Rails.fire(this.element, 'submit')
  }

  unsaved() {
    this.alertTarget.classList.remove('d-none')
  }
}
